import { cls } from "reactutils"

type CustomItemProps = {
  name?: string
  active?: boolean
  choose?: Function
}

export function CheckButton({ name, active, choose }: CustomItemProps) {
  const clickFn = () => {
    choose?.()
  }
  return (
    <>
      <div className={cls("img-c", active && "active")} onClick={clickFn}>
        {name}
        {active && <div className="active-icon"></div>}
      </div>
      <style jsx>{`
        .img-c {
          background: #ffffff;
          border: 1px solid #e7e7e7;
          border-radius: 2px;
          font-size: 14px;
          color: #333333;
          display: flex;
          position: relative;
          height: 32px;
          padding: 6px 26px;
          align-items: center;
          width: fit-content;
          white-space: nowrap;
        }
        .active {
          border-color: var(--shop-primary-color);
        }
        .active-icon {
          display: block;
          position: absolute;
          right: -8px;
          bottom: -8px;
          border: 8px solid transparent;
          border-top: 8px solid var(--shop-primary-color);
          transform: rotate(-45deg);
          -ms-transform: rotate(-45deg);
          -moz-transform: rotate(-45deg);
          -webkit-transform: rotate(-45deg);
        }

        .active-icon::after {
          content: "";
          position: absolute;
          left: -2px;
          top: -6px;
          width: 6px;
          height: 3px;
          border-color: transparent transparent #fff #fff;
          border-style: solid;
          border-width: 1px;
        }
      `}</style>
    </>
  )
}
